module.exports = __webpack_public_path__ + "static/media/event certificate.0436bd76.svg";